import React from 'react';
import { useLocation, Link } from 'react-router-dom';

const PaymentSuccess = () => {
  const { state } = useLocation();

  if (!state) {
    return (
      <div className="min-h-screen bg-[#02042b] flex flex-col items-center justify-center text-white p-8">
        <h1 className="text-3xl font-bold mb-4">No Payment Details Found</h1>
        <p className="mb-6">It looks like this page was accessed incorrectly.</p>
        <Link
          to="/checkout/order-details"
          className="px-6 py-3 bg-yellow-500 text-black rounded hover:bg-yellow-600"
        >
          Start a New Order
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#02042b] flex flex-col items-center justify-center p-8 text-white max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-6">Payment Successful!</h1>
      <p className="text-lg mb-8">Thank you for your payment. Your order has been received.</p>

      <Link
        to="/"
        className="mt-8 px-6 py-3 bg-[#373057] text-white rounded hover:bg-[#4a4882]"
      >
        Return Home
      </Link>
    </div>
  );
};

export default PaymentSuccess;
